import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { IMAGES } from "@/lib/site";
import CredentialModal from "./CredentialModal";

export default function Hero() {
  const [credDoc, setCredDoc] = useState(null);

  return (
    <section id="top" data-testid="hero-section" className="relative w-full min-h-[100svh] overflow-hidden">
      <img
        src={IMAGES.hero}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/95" />
      <div className="absolute inset-0 es-noise opacity-40" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-40 pb-24 lg:pt-48 lg:pb-32 flex flex-col min-h-[100svh] justify-between">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 mb-8" data-testid="hero-eyebrow">
            <span className="h-px w-10 bg-[#D4A84B]" />
            <span className="es-label text-[#D4A84B]">Milwaukee · Wisconsin</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-serif-display text-white text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight"
          >
            Roofing built for
            <br className="hidden sm:block" />
            <span className="italic text-[#D4A84B]">Wisconsin</span> weather.
          </h1>

          <p
            data-testid="hero-subhead"
            className="mt-8 max-w-2xl text-white/80 text-lg sm:text-xl leading-relaxed"
          >
            Local Milwaukee contractors specializing in roofing, gutters, siding,
            soffit, fascia, and exterior storm restoration. Honest estimates, clean
            job sites, and exterior systems built for Wisconsin weather.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start gap-4">
            <a href="#estimate" data-testid="hero-cta-primary" className="es-btn-primary">
              Get Free Estimate <ChevronRight className="w-4 h-4" />
            </a>
            <a href="#work" data-testid="hero-cta-secondary" className="es-btn-secondary">
              See Recent Work
            </a>
          </div>

          {/* Credential verification links */}
          <div className="mt-8" data-testid="hero-credential-links">
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              <button
                type="button"
                onClick={() => setCredDoc("gaf")}
                data-testid="hero-link-gaf-certificate"
                className="text-[#D4A84B] hover:text-[#FFBF00] text-sm font-semibold underline underline-offset-4 decoration-[#D4A84B]/40 hover:decoration-[#FFBF00] transition-colors"
              >
                View our GAF Certificate
              </button>
              <button
                type="button"
                onClick={() => setCredDoc("license")}
                data-testid="hero-link-wi-license"
                className="text-[#D4A84B] hover:text-[#FFBF00] text-sm font-semibold underline underline-offset-4 decoration-[#D4A84B]/40 hover:decoration-[#FFBF00] transition-colors"
              >
                View our Wisconsin License
              </button>
            </div>
          </div>
        </div>

        <div className="hidden sm:flex mt-16 flex-wrap items-center gap-x-10 gap-y-4 border-t border-white/10 pt-8 text-white/70 text-sm">
          <span data-testid="hero-trust-item" className="flex items-center gap-2 font-semibold">
            <span className="h-1 w-1 rounded-full bg-[#FFBF00]" /> GAF Certified Contractor
          </span>
          <span data-testid="hero-trust-item" className="flex items-center gap-2">
            <span className="h-1 w-1 rounded-full bg-[#D4A84B]" /> Licensed & Insured
          </span>
          <span data-testid="hero-trust-item" className="flex items-center gap-2">
            <span className="h-1 w-1 rounded-full bg-[#D4A84B]" /> Storm & Hail Specialists
          </span>
          <span data-testid="hero-trust-item" className="flex items-center gap-2">
            <span className="h-1 w-1 rounded-full bg-[#D4A84B]" /> Free Estimates for Most Homes
          </span>
          <span data-testid="hero-trust-item" className="flex items-center gap-2">
            <span className="h-1 w-1 rounded-full bg-[#D4A84B]" /> Clean Job Sites
          </span>
        </div>
      </div>

      <CredentialModal doc={credDoc} onClose={() => setCredDoc(null)} />
    </section>
  );
}
